import { ReduxState } from 'src/store/types';

export const isRefreshingDatabasesSelector = (state: ReduxState) =>
  state.databases.pendingRefreshDatabases;
